<template>
    <kgr-form-scaffold
        :pending="loading"
        with-primary-buttons
        :with-back-button="false"
        :save-button-disabled="!saveEnabled"
        :save-button-label="$t('Urlaubsansprüche speichern')"
        @primaryBtnClicked="save"
    >

        <kgr-note-box text-key="Hier können die Resturlaube der Mitarbeitenden aus dem Vorjahr für das aktuelle Jahr übertragen werden. Wählen Sie dafür die entsprechenden Personen aus und klicken auf Speichern um die Einträge für die Resturlaube des Vorjahrs in den Urlaubsansprüchen für dieses Jahr zu erzeugen. Bitte beachten Sie, dass Urlaubseinträge die jahresübergreifend eingetragen sind, vom Anspruch des Jahres abgezogen wird, in dem der Urlaub startet. Um das zu vermeiden, teilen Sie die Urlaubseinträge auf die einzelnen Jahre auf." />
        <br/>
        <kgr-table style="width: 100%" :is-data-table="false">
            <thead>
                <tr class="kgr-table__row">
                    <th class="kgr-table__cell kgr-table__cell--headline">
                        <label class="kgr-checkbox">
                            <input
                                type="checkbox"
                                class="kgr-checkbox__control"
                                :checked="selected.length === nonBalancedEmployees.length && selected.length > 0"
                                @change="toggleAll"
                            />
                        </label>
                    </th>
                    <th class="kgr-table__cell kgr-table__cell--headline" v-t="'Vorname'"></th>
                    <th class="kgr-table__cell kgr-table__cell--headline" v-t="'Nachname'"></th>
                    <th class="kgr-table__cell kgr-table__cell--headline" v-t="'Urlaubsanspruch Vorjahr'"></th>
                    <th class="kgr-table__cell kgr-table__cell--headline" v-t="'Übertrag aktuelles Jahr'"></th>
                    <th class="kgr-table__cell kgr-table__cell--headline" v-t="'Status'"></th>
                </tr>
            </thead>
            <tbody>
                <tr
                    v-for="(employee, index) in employees"
                    :key="index"
                    class="kgr-table__row kgr-table__cell"
                    :class="{ inactive: employee.balanced }"
                >
                    <td class="kgr-table__cell">
                        <kgr-checkbox
                            :readonly="employee.balanced"
                            :checked="selected.includes(employee)"
                            @change="updateSelection(employee, $event)"
                        />
                    </td>
                    <td class="kgr-table__cell">
                        <a
                            :href="`/backend/employee/vacation/${employee.id}`"
                            class="kgr-link"
                        >
                            {{ employee.firstName }}
                        </a>
                    </td>
                    <td class="kgr-table__cell">
                        <a
                            :href="`/backend/employee/vacation/${employee.id}`"
                            class="kgr-link"
                        >
                            {{ employee.lastName }}
                        </a>
                    </td>
                    <td class="kgr-table__cell">{{ localizeFloat(employee.vacationDaysLastYear) }}</td>
                    <td
                        class="kgr-table__cell"
                        :class="{negative: employee.carryOver < 0 }"
                    >{{ localizeFloat(employee.carryOver) }}</td>
                    <td
                        class="kgr-table__cell"
                    >
                        <kgr-icon-active
                            v-if="employee.balanced"
                            :title="$t('Es ist keine Anpassung des Urlaubsanspruchs erforderlich.')"
                        />
                        <kgr-icon-active
                            :title="$t('Markieren Sie diese Zeile, wenn Sie den Urlaubsanspruch aus dem Vorjahr in das aktuelle Jahr übernehmen möchten.')"
                            v-else
                            disabled
                        />
                    </td>
                </tr>
            </tbody>
        </kgr-table>
    </kgr-form-scaffold>
</template>

<script>
import Checkbox from '../../components/common/form/checkbox/Checkbox.vue';
import Error from '../../js/model/Error';
import FormScaffold from '../../components/common/form/FormScaffold.vue';
import IconActive from '../../components/common/icon/IconActive.vue';
import NoteBox from '../../components/common/NoteBox.vue';
import axios from 'axios';


export default {
    components: {
        'kgr-form-scaffold': FormScaffold,
        'kgr-checkbox': Checkbox,
        'kgr-note-box': NoteBox,
        'kgr-icon-active': IconActive,
    },
    props: {
        kindergartenId: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            selected: [],
            loading: false,
            error: new Error(),
            employees: [],
        };
    },
    computed: {
        saveEnabled() {
            return this.selected.length > 0;
        },
        nonBalancedEmployees() {
            return this.employees.filter(e => !e.balanced);
        }
    },
    mounted() {
        this.load();
    },
    methods: {
        localizeFloat(floatValue) {
            return Number(floatValue).toLocaleString(navigator.language);
        },
        updateSelection(employee, checked) {
            if(checked) {
                this.selected.push(employee);
            } else {
                this.selected = this.selected.filter(e => e.id !== employee.id);
            }
        },
        toggleAll() {
            if(this.selected.length === this.nonBalancedEmployees.length) {
                this.selected = [];
            } else {
                this.selected = [...this.nonBalancedEmployees];
            }
        },
        reload(){
            const selected = this.selected;
            this.load().then(() => {
                this.selected = this.employees.filter(e => selected.some(s => s.id === e.id));
            });
        },
        load(){
            this.loading = true;
            return axios.get(`/kindergartens/${this.kindergartenId}/employees/vacation-carry-over`)
                .then(response => {
                    this.employees = response.data.data;
                })
                .catch(() => {
                    this.$notify.error('error.loadingData');
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        save(){
            this.loading = true;
            const params = this.selected.map(e => {
                return {
                    id: e.id,
                    carryOver: e.carryOver,
                    vacationDaysLastYear: e.vacationDaysLastYear,
                };
            });
            axios.post(`/kindergartens/${this.kindergartenId}/employees/vacation-carry-over`, {
                employees: params
            })
                .then(() => {
                    this.$notify.success('saveChanges.success');
                    this.selected = [];
                    this.load();
                })
                .catch(error => {
                    if(error.response.status === 400) {
                        this.$notify.error('Ihre Änderungen konnten nicht gespeichert werden. Grund dafür könnte sein, dass sich die zugrundeliegenden Daten zwischenzeitlich geändert haben. Bitte versuchen Sie es erneut.');
                    } else {
                        this.$notify.error('error.loadingData');
                    }
                    this.reload();
                })
                .finally(() => {
                    this.loading = false;
                });
        }
    },
}
</script>

<style scoped>
.negative {
    background-color: #F5C2C2;
}
.inactive td {
    opacity: 0.5;
}
</style>
